import { plural } from '../../../utils/plural';

// Hidden when there's nothing (or nothing known) to review.
export function ToReviewPill({ count }: { count: number | null }) {
    if (count === null || count <= 0) return null;
    return (
        <span
            aria-label={`${plural(count, 'message')} to review`}
            className="inline-flex items-center rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-700 tabular-nums"
        >
            {count.toLocaleString()} to review
        </span>
    );
}
